var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GenericCrud',{attrs:{"route-name":"SettingsInternalRecipientCategories","route-action":"list","navbar-title":_vm.$t('settings.internalRecipientCategory.buttonLabel'),"navbar-back-route-without-history":{ name: 'Settings' },"main-list-filter-label":_vm.$t('settings.internalRecipientCategory.filterLabel'),"main-fist-scroll-to-selected":"","storeData":{
            mainListItems: {
                action: 'internalRecipientCategories/fetch',
                payload: { force: true },
                options: null,
                itemText: 'title',
                disableSorting: true,
            },
            mainItemById: {
                action: 'internalRecipientCategories/fetchById',
                payload: null,
                options: null,
            },
            edit: {
                action: 'internalRecipientCategories/edit',
                payload: null,
                options: null,
                refetch: true,
                hideButton: true
            },
            add: {
                action: 'internalRecipientCategories/create',
                payload: null,
                options: null,
            },
            delete: {
                action: 'internalRecipientCategories/delete',
                payload: null,
                options: null,
                hideButton: true
            },
            findUsage: {
                action: 'internalRecipientCategories/findUsage',
                payload: null,
                options: null,
                hideButton: true
            },
            replace: {
                action: 'internalRecipientCategories/replaceItemInRecord',
                options: null,
                hideButton: true
            },
        },"newItemModelFields":{
            clientId: null,
            isDepartment: false,
            locale: _vm.currentLanguage,
            translations: _vm.defaultTranslations,
        }},scopedSlots:_vm._u([{key:"editorMask",fn:function(x){return [_c('EditorMask',{key:x.id,attrs:{"available-languages":_vm.availableLanguages,"current-language":_vm.currentLanguage,"isWaiting":x.isWaiting,"isModified":x.isModified},on:{"modified":x.onSetModified,"onSaveItem":x.onSaveItem,"onDeleteItem":x.onDeleteItem,"onFindUsage":x.onFindUsage,"onCreateItem":x.onCreateItem},model:{value:(x.selectedMainItem),callback:function ($$v) {_vm.$set(x, "selectedMainItem", $$v)},expression:"x.selectedMainItem"}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }